
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Input } from '@/components/ui/input';
import { Search, Plus } from 'lucide-react';

interface FasClube {
  id: string;
  nome: string;
  cidade: string;
  descricao: string;
  logo: string;
  membros: any[];
  createdAt: string;
  owner: string;
}

const FasClubes = () => {
  const [fasClubes, setFasClubes] = useState<FasClube[]>([]);
  const [searchTerm, setSearchTerm] = useState('');
  
  useEffect(() => {
    // Load fan clubs from localStorage
    const storedFasClubes = localStorage.getItem('fasClubes');
    if (storedFasClubes) {
      setFasClubes(JSON.parse(storedFasClubes));
    }
  }, []);
  
  const filteredFasClubes = fasClubes.filter(clube => 
    clube.nome.toLowerCase().includes(searchTerm.toLowerCase()) || 
    clube.cidade.toLowerCase().includes(searchTerm.toLowerCase())
  );
  
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <div className="flex-1 container mx-auto px-4 pt-24 pb-10">
        <div className="flex flex-col md:flex-row justify-between items-center mb-6">
          <h1 className="text-3xl font-bold mb-4 md:mb-0">Fãs Clubes</h1>
          <div className="flex gap-4 w-full md:w-auto">
            <div className="relative flex-1 md:w-64">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} />
              <Input 
                type="text" 
                placeholder="Buscar fã clube..." 
                className="pl-10 bg-[#333] text-white border-none"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <Link 
              to="/fas-clube/cadastro" 
              className="bg-rustico-brown hover:bg-[#6f5f3f] text-white px-4 py-2 rounded-md flex items-center gap-2 transition-colors"
            >
              <Plus size={18} />
              <span className="hidden sm:inline">Criar Fã Clube</span>
            </Link>
          </div>
        </div>
        
        {filteredFasClubes.length === 0 ? (
          <div className="bg-black/60 p-8 rounded-lg text-center">
            <p className="text-lg text-gray-300 mb-4">
              {searchTerm ? 'Nenhum fã clube encontrado para essa busca.' : 'Nenhum fã clube cadastrado ainda.'}
            </p>
            <Link 
              to="/fas-clube/cadastro" 
              className="bg-rustico-brown hover:bg-[#6f5f3f] text-white px-6 py-3 rounded-md inline-flex items-center gap-2 transition-colors"
            >
              <Plus size={18} />
              Crie o primeiro fã clube
            </Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredFasClubes.map(clube => (
              <Link 
                key={clube.id} 
                to={`/fas-clube/${clube.id}`}
                className="bg-black/60 p-6 rounded-lg hover:bg-black/80 transition-colors"
              >
                <div className="flex items-center mb-4">
                  <Avatar className="h-16 w-16 mr-4">
                    <AvatarImage src={clube.logo} alt={clube.nome} />
                    <AvatarFallback>{clube.nome.slice(0, 2).toUpperCase()}</AvatarFallback>
                  </Avatar>
                  <div>
                    <h3 className="text-xl font-semibold">{clube.nome}</h3>
                    <p className="text-sm text-gray-300">{clube.cidade}</p>
                  </div>
                </div>
                {clube.descricao && (
                  <p className="text-sm text-gray-300 mb-3 line-clamp-2">{clube.descricao}</p>
                )}
                <div className="flex justify-between items-center text-sm text-gray-400">
                  <span>{clube.membros.length} membros</span>
                  <span>Criado por {clube.owner}</span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default FasClubes;
